// extracted by mini-css-extract-plugin
export default {"mobileImageAndVideoToggleWrapper":"image-and-video-toggle-mobile-module__mobileImageAndVideoToggleWrapper--CQzsc"};